import { debounce } from 'lodash-es';
import React from 'react';
// Debounce timeout (ms).
const DEBOUNCE_TIMEOUT = 500;
/**
 * Hook for keeping the position of an element up to date.
 * @returns position: An object with the element's position. Values default to 0.
 * @returns ref: A react ref that needs to get attached to the element.
 */
export const useResizeObserver = () => {
    const ref = React.useRef(null);
    const [position, setPosition] = React.useState({
        left: 0,
        top: 0,
    });
    const onResize = React.useMemo(() => debounce(() => {
        const el = ref.current;
        if (el) {
            const rect = el.getBoundingClientRect();
            setPosition({ left: rect.left, top: rect.top });
        }
    }, DEBOUNCE_TIMEOUT), [ref]);
    React.useEffect(() => {
        const el = ref.current;
        if (!el) {
            return () => undefined;
        }
        const resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(el);
        return () => {
            resizeObserver.disconnect();
        };
    }, [onResize, ref]);
    return [position, ref];
};
